import { AthleteType } from '../../models/athlete';
import CLIENT_SETTINGS from '../../lib/client_settings';

export const getAthleteName = (athlete: AthleteType | false | undefined, defaultValue = '', short = false) => (!athlete
  ? defaultValue
  : short
    ? athlete.shortName || defaultValue
    : `${capitalize(athlete?.lastName) || ''} ${capitalize(athlete.firstName) || defaultValue}`);

export const getAthleteNumber = (athlete: AthleteType | false, teamId: string) => (athlete ? athlete?.playerSet?.find((set) => set.team?.id === teamId)?.number || '' : '');

export const getAthleteLink = (athlete: AthleteType) => `/athletes/${athlete?.id}`;

/**
 * Camel Case spaziato per stringhe
 *
 * @param name
 *
 * @todo verificare se utilizzabile al posto di convertToTitle
 */
export const capitalizeName = (name: string) => {
  if (!name || typeof name !== 'string') { // @todo temporary check
    return '';
  }
  return capitalize(name);
};

export const getLocalPicturePath = (pictureURL: string) => (pictureURL.slice(0, 4) !== 'http'
  ? `${CLIENT_SETTINGS.public.gpexeBackendUrl}${pictureURL.slice(1, pictureURL.length)}`
  : pictureURL);

export function capitalize(name: string) {
  if (!name) return '';
  const cleanedName = name.replace(/\s+/g, ' ').trim(); // remove possible extra white spaces
  const splt = cleanedName.toLowerCase().split(' ').map((t) => t[0].toUpperCase() + t.substring(1));
  return splt.join(' ');
}
